import { render, staticRenderFns } from "./matchingDetails.vue?vue&type=template&id=6b70a867&scoped=true&"
import script from "./matchingDetails.vue?vue&type=script&lang=js&"
export * from "./matchingDetails.vue?vue&type=script&lang=js&"
import style0 from "./matchingDetails.vue?vue&type=style&index=0&id=6b70a867&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b70a867",
  null
  
)

export default component.exports